"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkObjectsAndCrewLinks = void 0;
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var perf2_sidecar_1 = require("@engine/perf2-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var namespace = 'spyder-tilemap';
function checkObjectsAndCrewLinks() {
    var obj = diveTilemap_sidecar_1.diveTilemap.get();
    perf2_sidecar_1.perf2.measure('checkObjectsAndCrewLinks', function () {
        // Check tiles
        {
            for (var iTile = 0; iTile < obj.parts.length; iTile++) {
                var gs = obj.parts[iTile];
                if (!gs) {
                    assert_sidecar_1.assert.failed(namespace, 'no gs');
                }
                if (gs.crew.length > 0) {
                    for (var iCrew = 0; iCrew < gs.crew.length; iCrew++) {
                        var crew = gs.crew[iCrew];
                        if (crew.isUpStairs || crew.isDownStairs) {
                            assert_sidecar_1.assert.failed(namespace, 'crew is up/down stairs');
                        }
                        if (crew.i !== gs.i || crew.j !== gs.j) {
                            assert_sidecar_1.assert.failed(namespace, 'crew i/j mismatch');
                        }
                    }
                }
                if (gs.objects.length > 0) {
                    for (var iObject = 0; iObject < gs.objects.length; iObject++) {
                        var object = gs.objects[iObject];
                        if (object.i !== gs.i || object.j !== gs.j) {
                            assert_sidecar_1.assert.failed(namespace, 'object i/j mismatch');
                        }
                    }
                }
            }
            // Check crew
            {
                var crews = diveCrew_sidecar_1.diveCrew.getAll();
                for (var iCrew = 0; iCrew < crews.length; iCrew++) {
                    var crew = crews[iCrew];
                    if (crew.isDead) {
                        continue;
                    }
                    if (crew.isUpStairs || crew.isDownStairs) {
                        continue;
                    }
                    var gs = diveTilemap_sidecar_1.diveTilemap.getSafe(crew.i, crew.j);
                    if (!gs) {
                        assert_sidecar_1.assert.failed(namespace, 'crew tile not found', crew.i, crew.j, crew.heroState, crew.name, crew.heroType, crew.enemyType);
                    }
                    if (crew.tile !== gs) {
                        assert_sidecar_1.assert.failed(namespace, 'crew tile mismatch');
                    }
                    if (gs.crew.indexOf(crew) === -1) {
                        assert_sidecar_1.assert.failed(namespace, 'crew not in tile');
                    }
                }
            }
            // Check objects
            {
                var objects = diveObjects_sidecar_1.diveObjects.getAll();
                for (var iObject = 0; iObject < objects.length; iObject++) {
                    var object = objects[iObject];
                    if (object.i === -1 && object.j === -1) {
                        continue;
                    }
                    var gs = diveTilemap_sidecar_1.diveTilemap.getSafe(object.i, object.j);
                    if (!gs) {
                        assert_sidecar_1.assert.failed(namespace, 'object tile not found', object.isDead, object.i, object.j);
                    }
                    if (object.tile !== gs) {
                        assert_sidecar_1.assert.failed(namespace, 'object tile mismatch');
                    }
                    if (gs.objects.indexOf(object) === -1) {
                        assert_sidecar_1.assert.failed(namespace, 'object not in tile');
                    }
                }
            }
        }
    });
    // console.log(namespace, 'ok')
    // for (let i = 0; i < objects.length; i++) {
    //   let obj = objects[i]
    //   if (obj.crew) {
    //     assert.t(obj.crew.object === obj, 'crew object mismatch')
    //   }
    // }
}
exports.checkObjectsAndCrewLinks = checkObjectsAndCrewLinks;
